import * as React from "react";
import {
  StyleSheet,
  View,
  Text,
  TouchableHighlight,
  Linking,
  Dimensions,
} from "react-native";
const win = Dimensions.get("window").width;
const direction = win > 960 ? "row" : "column"
const today = new Date()
export default function FooterBarWide() {
  return (
    <View style={[styles.footerBar, { flexDirection: direction }]}>
      {/* <View style={styles.topContainer}> */}
      <View style={styles.menuContainerLeft}>
      <TouchableHighlight
          style={styles.tabContainer}
          onPress={() => Linking.openURL("https://aura.club/faqs/")}
        >
          <View>
            <Text style={styles.text}>FAQs&nbsp;&nbsp;|&nbsp;&nbsp;</Text>
          </View>
        </TouchableHighlight>
        {/* <TouchableHighlight
            style={styles.tabContainer}
            onPress={() => Linking.openURL("https://aurabuyinvestdonate.com/")}
          >
            <View>
              <Text style={styles.text}>Responsible</Text>
            </View>
          </TouchableHighlight> */}
        <TouchableHighlight
          style={styles.tabContainer}
          onPress={() => Linking.openURL("https://aura.club/terms-and-conditions/")}
        >
          <View>
            <Text style={styles.text}>Terms&nbsp;&&nbsp;Conditions&nbsp;&nbsp;|&nbsp;&nbsp;</Text>
          </View>
        </TouchableHighlight>
        <TouchableHighlight
          style={styles.tabContainer}
          onPress={() => Linking.openURL("https://aura.club/privacy-policy/")}
        >
          <View>
            <Text style={styles.text}>Privacy&nbsp;&nbsp;|&nbsp;&nbsp;</Text>
          </View>
        </TouchableHighlight>
        <TouchableHighlight
          style={styles.tabContainer}
          onPress={() => Linking.openURL("https://aura.club/important-documents/")}
        >
          <View>
            <Text style={styles.text}>Important Documents&nbsp;&nbsp;|&nbsp;&nbsp;</Text>
          </View>
        </TouchableHighlight>
        <TouchableHighlight
          style={styles.tabContainer}
          onPress={() => Linking.openURL("https://aura.club/contact/")}
        >
          <View>
            <Text style={styles.text}>&nbsp;Contact</Text>
          </View>
        </TouchableHighlight>
        {/* <TouchableHighlight
            style={styles.tabContainer}
            onPress={() => Linking.openURL("https://aurabuyinvestdonate.com/")}
          >
            <View>
              <Text style={styles.text}>Cookies</Text>
            </View>
          </TouchableHighlight> */}
      </View>
      {/* <View style={styles.menuContainerMid}>
          {/* <Text style={styles.copyRightText}>
            2021 AURA Buy Invest Donate Pty Ltd 
          </Text> 
          </View>*/}
      <View style={styles.menuContainerRight}><View style={styles.copyRightTextContainer}>
          <View style={styles.copyRightTextContainer}>
            <Text style={styles.copyRightText}>
              {'\u00A9'}&nbsp;{today.getFullYear()} AURA Buy Invest Donate Pty Ltd
            </Text>
          </View>
        </View>
       

      </View>
      {/* <View style={styles.menuContainerRight}>
        </View> */}
      {/* </View> */}
    </View>
  );
}
const styles = StyleSheet.create({
  footerBar: {
    flex: 1,
    backgroundColor: "#FFFF",
    paddingBottom: 20,
    paddingTop: 60,
    paddingLeft: 100,
    paddingRight: 100,
  },
  topContainer: {
    flex: 1,
    flexDirection: "row",
  },
  menuContainerLeft: {
    flex: 1,
    flexDirection: "row",
    alignSelf: "flex-start",
    paddingBottom: 10,
  },
  menuContainerRight: {
    // flex: 1,
    flexDirection: "row",
    alignItems: "flex-end",
    paddingBottom: 40,
  },
  menuContainerMid: {
    flex: 1,
    flexDirection: "row",
    alignContent: "center",
  },
  copyRightTextContainer: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "flex-start",
  },
  copyRightText: {
    color: "gray",
  },
  tabContainer: {
    justifyContent: "space-evenly",
    paddingRight: 10,
  },
  tabContainerRight: {
    justifyContent: "space-evenly",
    paddingLeft: 20,
  },
  iconLabelContainer: {
    alignContent: "center",
    flexDirection: "row",
    margin: 5,
    textAlign: "center",
  },
  iconContainer: {
    marginRight: 5,
    justifyContent: "center",
  },
});
